import { useParams, Link } from 'react-router-dom';
import { useApi } from '../hooks/useApi.js';
import { getSharedVirtualProduct } from '../api/virtualApi.js';
import VirtualDetail from './VirtualDetail.jsx';
import './VirtualDetailPage.css';

/**
 * 免登入分享頁：透過 /v/{token} 直接檢視單一虛擬商品，
 * 繞過會員制與 minLevel（後端以 token 驗證）。版型與一般詳情頁共用。
 */
function SharedVirtualPage() {
  const { token } = useParams();
  const { data: product, loading } = useApi(() => getSharedVirtualProduct(token), [token]);

  if (loading) {
    return <main className="vd"><div className="vd-loading">載入中…</div></main>;
  }
  if (!product) {
    return (
      <main className="vd">
        <p className="vd-empty">此分享連結無效或已失效。<Link to="/">返回首頁</Link></p>
      </main>
    );
  }

  return <VirtualDetail product={product} />;
}

export default SharedVirtualPage;
